import i18n from '../../../i18n'
import { DOC_FLOW_API_URL } from '../DocFlow.constants'
import { DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT } from '../DocFlowAddRecipientFields'

import {
  DOC_FLOW_COMBINING_ACTION_ADD_RECIPIENT,
  DOC_FLOW_COMBINING_ACTION_DELETE,
  DOC_FLOW_COMBINING_ACTION_EDIT_FINAL_DOCUMENT_TITLE,
  DOC_FLOW_COMBINING_ACTION_EDIT_RECIPIENT,
  DOC_FLOW_COMBINING_ACTION_EDIT_SEQUENCE,
  DOC_FLOW_COMBINING_FORM_FIELD_FINAL_FILE_NAME,
  DOC_FLOW_COMBINING_FORM_FIELD_ID,
  DOC_FLOW_COMBINING_MASS_ACTION_COMBINED,
  DOC_FLOW_COMBINING_MASS_ACTION_DELETE,
  DOC_FLOW_COMBINING_MASS_ACTION_EDIT_FINAL_DOCUMENT_TITLE,
  DOC_FLOW_COMBINING_MASS_ACTION_EDIT_FINAL_DOCUMENT_TITLE_FIELD,
  DOC_FLOW_COMBINING_MASS_ACTION_EDIT_SEQUENCE_DOCUMENT,
  DOC_FLOW_COMBINING_MASS_ACTION_UNCOMBINED,
  DOC_FLOW_COMBINING_TABLE_CONFIG_URL,
  DOC_FLOW_COMBINING_TABLE_FILTER_STATE_URL,
  DocFlowCombiningFieldName,
} from './DocFlowCombining.constants'

export function getTableApiUrls(id) {
  return {
    filterStateApi: `${DOC_FLOW_COMBINING_TABLE_FILTER_STATE_URL}?object_id=${id}`,
    listApi: `${DOC_FLOW_API_URL}${id}/combining-files/filter/`,
    tableConfigApi: DOC_FLOW_COMBINING_TABLE_CONFIG_URL,
  }
}

export function getFilterApi(id) {
  return `/api/document-stapling/document-staplings/${id}/combining-files/single-field/`
}

export function getParamsForAddingRecipients({ documentId, value }) {
  return {
    [DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT]: value[
      DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT
    ].map(item => item.value),
    [DOC_FLOW_COMBINING_FORM_FIELD_ID]: documentId,
  }
}

export function getCombiningTableItemActions({
  combined,
  permissions,
  uploading,
}) {
  return [
    ...(permissions.can_edit_recipient
      ? [
          {
            label:
              'DocumentStapling.CombiningTableEditRecipientActionOptionKey',
            permission: permissions.can_edit_recipient,
            value: DOC_FLOW_COMBINING_ACTION_EDIT_RECIPIENT,
          },
        ]
      : []),
    ...(combined && permissions.can_edit_final_file_name
      ? [
          {
            label:
              'DocumentStapling.CombiningTableEditFinalDocTitleActionOptionKey',
            permission: permissions.can_edit_final_file_name,
            value: DOC_FLOW_COMBINING_ACTION_EDIT_FINAL_DOCUMENT_TITLE,
          },
        ]
      : []),
    ...(combined && permissions.can_edit_uploading_sequence
      ? [
          {
            disabled: !uploading || uploading.length <= 1,
            label: 'DocumentStapling.CombiningTableEditSequenceActionOptionKey',
            permission: permissions.can_edit_uploading_sequence,
            tooltipContent: i18n.t(
              'DocumentStapling.CombiningTableEditSequenceActionTooltipKey'
            ),
            value: DOC_FLOW_COMBINING_ACTION_EDIT_SEQUENCE,
          },
        ]
      : []),
    null,
    ...(permissions.can_delete
      ? [
          {
            label: 'DocumentStapling.CombiningTableDeleteActionOptionKey',
            permission: permissions.can_delete,
            value: DOC_FLOW_COMBINING_ACTION_DELETE,
          },
        ]
      : []),
  ]
}

export function getMassActions(documentData) {
  return [
    {
      label: i18n.t(
        'DocumentStapling.CombiningTableEditFinalDocTitleActionOptionKey'
      ),
      value: DOC_FLOW_COMBINING_MASS_ACTION_EDIT_FINAL_DOCUMENT_TITLE,
    },
    {
      disabled: documentData.documents_count === 1,
      label: i18n.t(
        'DocumentStapling.CombiningTableEditSequenceActionOptionKey'
      ),
      tooltipContent: i18n.t(
        'DocumentStapling.CombiningTableEditSequenceActionTooltipKey'
      ),
      value: DOC_FLOW_COMBINING_MASS_ACTION_EDIT_SEQUENCE_DOCUMENT,
    },
    {
      label: i18n.t(
        'DocumentStapling.CombiningTableMakeCombinedActionOptionKey'
      ),
      value: DOC_FLOW_COMBINING_MASS_ACTION_COMBINED,
    },
    {
      label: i18n.t(
        'DocumentStapling.CombiningTableMakeUnCombinedActionOptionKey'
      ),
      value: DOC_FLOW_COMBINING_MASS_ACTION_UNCOMBINED,
    },
    null,
    {
      label: i18n.t('DocumentStapling.CombiningTableDeleteActionOptionKey'),
      value: DOC_FLOW_COMBINING_MASS_ACTION_DELETE,
    },
  ]
}

export function getEditFinalFileTitlePayload(values) {
  return {
    [DOC_FLOW_COMBINING_FORM_FIELD_FINAL_FILE_NAME]:
      values[DOC_FLOW_COMBINING_FORM_FIELD_FINAL_FILE_NAME],
  }
}

export function getEditFinalFileTitleMassPayload(values) {
  return {
    [DOC_FLOW_COMBINING_MASS_ACTION_EDIT_FINAL_DOCUMENT_TITLE_FIELD]:
      values[DOC_FLOW_COMBINING_MASS_ACTION_EDIT_FINAL_DOCUMENT_TITLE_FIELD],
  }
}

export function getCombiningTableNotificationTitle(action) {
  switch (action) {
    case DOC_FLOW_COMBINING_ACTION_DELETE:
      return i18n.t('Notification.CommonTitleDeletedKey')
    default:
      return i18n.t('Notification.CommonTitleSavedKey')
  }
}

export function checkExistNotFoundUsers(items) {
  return items?.some(item => !item[DocFlowCombiningFieldName.Recipient])
}

export function getAsyncNotificationText({ action, t }) {
  switch (action) {
    case DOC_FLOW_COMBINING_ACTION_EDIT_SEQUENCE:
      return t('Notification.DocumentStaplingAsyncTextEditSequenceKey')

    case DOC_FLOW_COMBINING_ACTION_ADD_RECIPIENT:
      return t('Notification.DocumentStaplingAsyncTextAddRecipientKey')

    case DOC_FLOW_COMBINING_MASS_ACTION_EDIT_SEQUENCE_DOCUMENT:
      return t('Notification.DocumentStaplingAsyncTextMassEditSequenceKey')

    default:
      return null
  }
}

export function getNotificationTitle({ action, count, t, totalCount }) {
  switch (action) {
    case DOC_FLOW_COMBINING_ACTION_EDIT_SEQUENCE:
      return t('Notification.DocumentStaplingTitleEditSequenceKey')

    case DOC_FLOW_COMBINING_MASS_ACTION_EDIT_SEQUENCE_DOCUMENT:
      return t('Notification.DocumentStaplingMassTitleEditSequenceKey', {
        count,
        totalCount,
      })

    case DOC_FLOW_COMBINING_ACTION_ADD_RECIPIENT:
      return t('Notification.DocumentStaplingMassTitleAddRecipientKey', {
        count,
        totalCount,
      })

    case DOC_FLOW_COMBINING_MASS_ACTION_DELETE:
      return t('Notification.DocumentStaplingMassTitleDeleteKey', {
        count,
        totalCount,
      })

    case DOC_FLOW_COMBINING_MASS_ACTION_COMBINED:
      return t('Notification.DocumentStaplingMassTitleCombinedKey', {
        count,
        totalCount,
      })

    case DOC_FLOW_COMBINING_MASS_ACTION_UNCOMBINED:
      return t('Notification.DocumentStaplingMassTitleUncombinedKey', {
        count,
        totalCount,
      })

    case DOC_FLOW_COMBINING_MASS_ACTION_EDIT_FINAL_DOCUMENT_TITLE:
      return t('Notification.DocumentStaplingMassTitleEditFilenameKey', {
        count,
        totalCount,
      })

    default:
      return null
  }
}

export function isDocFlowCombiningPhaseLoading(percent) {
  return percent < 100
}
